import { useEffect } from "react";

export function useTitle(...titleParts: (string | undefined | null | false)[]) {
  useEffect(() => {
    const title = titleParts.filter(Boolean).join(" - ");

    const fullTitle = `${title} | ${import.meta.env.VITE_APP_NAME}`;
    document.title = fullTitle;
  }, [titleParts]);
}
